import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { Input, FormFeedback, NavLink } from 'reactstrap';
import { firebase } from './utils/firebase';
import { BarLoader } from 'react-spinners';


class Home extends Component {
    constructor() {
        super()
        this.state = {
            email: '',
            password: '',
            isSignedIn: false,
            currentUser: '',
            invalidCreds: false,
            loading: true,
        }
        this.onSubmit = this.onSubmit.bind(this)
        this.onHandleChange = this.onHandleChange.bind(this)
        this.checkLogin = this.checkLogin.bind(this)

    }

    componentDidMount() {
      //  firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
        setTimeout(() => {
            this.checkLogin()
            this.setState({loading:false});
        }, 2000);
     }

     checkLogin(){
        var user = firebase.auth().currentUser;
            if (user) {
                this.setState({
                    isSignedIn: true,
                    currentUser: user,
                  });
            // User is signed in.
            } else {
            // No user is signed in.
            }
     }  


    onSubmit(e) {
        e.preventDefault();
        var email = this.state.email;
        var password = this.state.password;

        
        firebase.auth().signInWithEmailAndPassword(email, password)
        .then(() => {
            const userInfo = firebase.auth().currentUser;
            this.setState({
              isSignedIn: true,
              currentUser: userInfo,
            });
          })
          .catch((error) => {
            this.setState({
                invalidCreds: true,
            })
          });
    }

    onHandleChange(e) {
        let name = e.target.name;
        this.setState({
            [name]: e.target.value
        }) 
    }
    
    render() {
        const user = this.state.currentUser;
        return (
              <div className="sub50">
                <div id="loginBlock">
                {this.state.isSignedIn ? 
                    <div>
                        <h3>You are logged in!</h3>
                        <br></br>
                        <Link to="/profile" user={user}>Click here to view and edit your profile.</Link>
                    </div>
                    :
                    <div>
                        {
                        this.state.loading ? 
                        <div className="CenterImage">
                             <BarLoader sizeUnit={"px"} size={100} color={'#251F5F'} loading={true}/>
                        </div> :
                        <div>
                        <h5>Animal Owner & Business Login</h5>
                            <Input type="email" name="email" value={this.state.email} placeholder="Email" onChange={this.onHandleChange} invalid={this.state.invalidCreds}/>
                            <FormFeedback invalid>Oops! We can't find a user with those credentials</FormFeedback>
                        <br />
                     
                        <Input type="password" name="password" value={this.state.password} placeholder="Password" onChange={this.onHandleChange}/>
                        <br />
                        <button className="primary" onClick={this.onSubmit}>Sign In</button>
                        <br />
                        <NavLink justify="true" href="/passwordReset" className="justify-content-center">Forgot password?</NavLink>
                        </div>
                        }
                    
                    </div>
                }
                </div>
          </div>
        )
    }
}

export default Home



// WEBPACK FOOTER //
// ./src/home.js